<template>

<!-- <p>（メモ：申込状況などの制御 加筆）</p> -->
<!-- <p>(活動分野リストの仮)<br>
<ul class="bunya_list">
	<li class="korei_icon">高齢者関係</li>
	<li class="syogai_icon">障がい児・者関係</li>
	<li class="jido_icon">児童関係</li>
	<li><fa icon="briefcase-medical" class="icon hoken_icon" />保健・医療関係</li>
	<li class="sonota_icon">その他</li>
</ul>
</p> -->
<ul>
    <li class="item_area" v-for="itemData in items" :key="itemData.id">
        <div v-if="(itemData.hyoji_code === 1)" class="item_detail flex" @click="openModal(itemData)">
            <div class="item_detail_text">
				<!-- タイトル -->
				<div class="item_title flex reflex">
					<!-- 受付状態 -->
					<div class="item_status">
						<span v-if="(itemData.jyokyo_code !== 1)" class="mosikomi_imp">申込停止</span>
						<span v-else-if="(new Date(itemData.kikan_to)) < TODAY" class="mosikomi_imp">申込不可</span>
						<span v-else class="mosikomi_poss">受付中</span>
					</div>
					<!-- 施設名 -->
					<div class="item_sisetuname">
						<span>{{itemData.sisetu_name}}</span>
					</div>
				</div>			
				<!-- 内容 -->
				<div class="flex">
				<!-- 活動分野と受入階層 -->
					<div class="status_box w30">
						<ul class="bunya_list">
							<li v-if="itemData.katudo_bunya_id === 1" class="korei_icon">
								<span class="bunya_text">高齢者関係</span>
							</li>
							<li v-if="itemData.katudo_bunya_id === 2" class="syogai_icon">
								<span class="bunya_text">障がい児・者関係</span>
							</li>
							<li v-if="itemData.katudo_bunya_id === 3" class="jido_icon">
								<span class="bunya_text">児童関係</span>
							</li>
							<li v-if="itemData.katudo_bunya_id === 4" class="hoken_icon">
								<span class="bunya_text">保健・医療関係</span>
							</li>
							<li v-if="itemData.katudo_bunya_id === 5" class="sonota_icon">
								<span class="bunya_text">その他</span>
							</li>
						</ul>
						<ul class="flex ukeire_box">
						<li><span class="ukeire ukeire_syogaku" v-if="itemData.uke_syogaku_check === 1">小</span></li>
						<li><span class="ukeire ukeire_cyugaku" v-if="itemData.uke_cyugaku_check === 1">中</span></li>
						<li><span class="ukeire ukeire_koko" v-if="itemData.uke_koko_check === 1">高</span></li>
						<li><span class="ukeire ukeire_tansen" v-if="itemData.uke_tansen_check === 1">短</span></li>
						<li><span class="ukeire ukeire_daigaku" v-if="itemData.uke_daigaku_check === 1">大</span></li>
						<li><span class="ukeire ukeire_syuhu" v-if="itemData.uke_syuhu_check === 1">主</span></li>
						<li><span class="ukeire ukeire_kaisya" v-if="itemData.uke_kaisya_check === 1">会</span></li>
						<li><span class="ukeire ukeire_korei" v-if="itemData.uke_korei_check === 1">齢</span></li>
						<li><span class="ukeire ukeire_syogai" v-if="itemData.uke_syogai_check === 1">障</span></li>
						</ul>
						<!-- 学生ポイント・福祉サポーター対象など -->
						<div class="flex">
							<span v-if="(itemData.gakusei === 1)" class="ukeire_tag_g">学生ポイント制度対象</span>
							<span v-else class="ukeire_tag_g _false">学生ポイント制度対象</span>
							<span v-if="(itemData.supporter_check === 1)" class="ukeire_tag">地域福祉サポーター対象</span>
							<span v-else class="ukeire_tag _false">地域福祉サポーター対象</span>
						</div>
					</div>		
					<div class="w35">
						<dl>
							<dt class="detail_title">内容
								<span class="henko" v-if="itemData.henkonaiyo">※変更があります</span>
							</dt>
							<dd class="detail_content clampText">{{itemData.naiyou}}</dd>
							<!-- 赤色のCSSは仮 -->
							<!-- <dd class="detail_content clampText henko" v-if="itemData.henkonaiyo">{{itemData.henkonaiyo}}</dd> -->
						</dl>
					</div>
					<div class="w35">
						<dl>
							<dt class="detail_title">活動期間・時間</dt>
							<dd class="detail_content">
								<span>{{format(new Date(itemData.kikan_from),'yyyy/MM/dd(E)',{locale: ja})}} ～ {{format(new Date(itemData.kikan_to),'yyyy/MM/dd(E)',{locale: ja})}}</span>
								<div class="flex item_box">
									<ul class="flex youbi">
										<li v-if="itemData.week1_check === 1"><span class="week">月</span></li>
										<li v-if="itemData.week2_check === 1"><span class="week">火</span></li>
										<li v-if="itemData.week3_check === 1"><span class="week">水</span></li>
										<li v-if="itemData.week4_check === 1"><span class="week">木</span></li>
										<li v-if="itemData.week5_check === 1"><span class="week">金</span></li>
										<li v-if="itemData.week6_check === 1"><span class="week">土</span></li>
										<li v-if="itemData.week7_check === 1"><span class="week">日</span></li>
										<li v-if="itemData.week1_check !== 1 && itemData.week2_check !== 1 && itemData.week3_check !== 1 && itemData.week4_check !==1 && itemData.week5_check !== 1 && itemData.week6_check !== 1 && itemData.week7_check !== 1">曜日にかかわらず</li>
									</ul>
									<span class="time_height">{{itemData.jikan_from}}～{{itemData.jikan_to}}</span>
								</div>
							</dd>
						</dl>
						<!-- <div>
							<a v-if="itemData.url" :href="itemData.url" class="btn_link" target="_blank"><button class="btn_link btn_on btn_hp_map"><fa icon="home" class="icon" />HP</button></a>
							<a v-else class="btn_link" target="_blank"><button class="btn_link _off btn_hp_map"><fa icon="home" class="icon" />HP</button></a>
							<a v-if="itemData.map_url" :href="itemData.map_url" class="btn_link" target="_blank"><button class="btn_link btn_on btn_hp_map"><fa icon="map-marked-alt" class="icon" />MAP</button></a>
							<a v-else class="btn_link" target="_blank"><button class="btn_link _off btn_hp_map" disabled><fa icon="map-marked-alt" class="icon" />MAP</button></a>
						</div>-->
					</div>
				</div>
            </div>
        </div>
    </li>
</ul>
		<!-- モーダルウィンドウ -->
		<transition name="modal-fade">
		<modal-window v-show="showContent" :item="postItem" :To_kikan="To_kikan" :From_kikan="From_kikan" @close="closeModal" />
		</transition>
<!-- <base-pagination
    :show-pages="showPages"
    :current-page="currentPage"
    :total-count="totalCount"
    :total-pages="totalPages"
    :per-page="perPage"
    @currentPage="changePage"
    /> -->
</template>

<script>
// import { inject } from 'vue'
import ModalWindow from './ModalWindow.vue';
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
// import BasePagination from './BasePagination.vue';
// モーダル時背景固定
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
export default {
    name:`menuitem`,
    props: {
        items: Array
    },
	data() {
		const TODAY = new Date();
		return {
			showContent: false,
			postItem: Array,
			TODAY,
			From_kikan: String,
			To_kikan: String,
		}
	},
    components: {
        ModalWindow,
		// BasePagination,
    },
    setup () {
		// const { keywords } = inject('searchinfo');
		return {
			// keywords,
			// 日付の書式
			format,
			ja,
		}
    },
	watch: {
		$route(to, from) {
			if (to !== from) {
				// const targetElement = document.querySelector('#modalcont');
				const targetElement = document.querySelector('.scroll-detail');
				enableBodyScroll(targetElement);
			}
		}
	},
	methods: {
		openModal: function(item) {
			this.showContent = true
			this.From_kikan = format((new Date(item.kikan_from)),'yyyy/MM/dd(E)',{locale: ja})
			this.To_kikan = format((new Date(item.kikan_to)),'yyyy/MM/dd(E)',{locale: ja})
			this.postItem = item
			// const targetElement = document.querySelector('#modalcont');
			const targetElement = document.querySelector('.scroll-detail');
			disableBodyScroll(targetElement);
		},
		closeModal: function() {
			this.showContent = false;
			// this.postItem = [];
			// const targetElement = document.querySelector('#modalcont');
			const targetElement = document.querySelector('.scroll-detail');
			enableBodyScroll(targetElement);
		},
	},
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.3s;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
	opacity: 0;
}
</style>